"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionMoreActions_1 = require("../../../../../../shared/components/table_actions/TableActionMoreActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var TableActionUser_1 = require("../../../../../../shared/components/table_actions/TableActionUser");
var PartnersList = /** @class */ (function (_super) {
    __extends(PartnersList, _super);
    function PartnersList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchLoginInput = null;
        _this.searchEMailInput = null;
        _this.action_more_get_pass = "action:get-password";
        _this.action_more_set_pass = "action:set-password";
        _this.ACTION_NEW_PARTNER = "ACTION_NEW_PARTNER";
        _this.ACTION_NEW_BROADCAST_RAW = "ACTION_NEW_BROADCAST_RAW";
        _this.LOGIN_FILTER = "PartnersList-LoginFilter";
        _this.EMAIL_FILTER = "PartnersList-EmailFilter";
        _this.PAGE_NUM_ONE = 1;
        return _this;
    }
    PartnersList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    PartnersList.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.LOGIN_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.EMAIL_FILTER);
        }
        this.setState({
            searchLoginFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).selectedValues,
            searchLoginValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).filterValue,
            isSearchLogin: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).isFilterActive,
            searchEMailFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).selectedValues,
            searchEMailValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).filterValue,
            isSearchEmail: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).isFilterActive,
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.doReLoadPartnersList();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    PartnersList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PartnersList.prototype.doReLoadPartnersList = function (cb) {
        this.props.data.LoadData({
            all_pprograms: this.props.allAffilates,
            pprogram_id_list: this.props.affilatesList,
            offset: this.getDataOffset(),
            limit: this.state.pageSize,
            is_filter_email_part: this.state.isSearchEmail,
            email_part: this.state.searchEMailValue,
            is_filter_login_part: this.state.isSearchLogin,
            login_part: this.state.searchLoginValue
        }, function () {
            if (cb) {
                cb();
            }
        });
    };
    PartnersList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                _this.doReLoadPartnersList();
            });
        }
    };
    //http://jsfiddle.net/sujit77/9d6yrom9/69/
    //https://github.com/SheetJS/js-xlsx
    PartnersList.prototype.doMorection = function (e, record) {
        var _this = this;
        if (e.key == this.action_more_get_pass) {
            this.props.data.GetPartnerPassword(record.key, function (pass) {
                _this.props.dlgView.SetTitle("\u041F\u0430\u0440\u043E\u043B\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 : " + record.login + " ").SetText(pass).Show();
            });
        }
        if (e.key == this.action_more_set_pass) {
            this.props.dlgPwd.clearFields().SetOnYesClick(function (newpass) {
                _this.props.data.SetPartnerNewPassword(record.key, newpass, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.login,
                            "]"),
                        " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
                });
            }).Show();
        }
    };
    PartnersList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_more_get_pass },
                React.createElement(FontAwesome_1.FA, { icon: "eye", left: true }),
                "\u0423\u0437\u043D\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_pass },
                React.createElement(FontAwesome_1.FA, { icon: "key", left: true }),
                "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C")));
    };
    PartnersList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetPartnerIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PartnersList.prototype.onClearLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [],
            searchLoginValue: "",
            isSearchLogin: false,
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.LOGIN_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.LOGIN_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.LOGIN_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
            // this.doReLoadPlayersList();
        });
    };
    PartnersList.prototype.onClearEMailFilter = function () {
        var _this = this;
        this.setState({
            searchEMailFilter: [],
            searchEMailValue: "",
            isSearchEmail: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.EMAIL_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.EMAIL_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.EMAIL_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
            // this.doReLoadPlayersList();
        });
    };
    PartnersList.prototype.onChangeLoginFilter = function (e) {
        var _this = this;
        this.setState({
            searchLoginValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.LOGIN_FILTER, _this.state.searchLoginValue);
        });
    };
    PartnersList.prototype.onChangeEMailFilter = function (e) {
        var _this = this;
        this.setState({
            searchEMailValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.EMAIL_FILTER, _this.state.searchEMailValue);
        });
    };
    PartnersList.prototype.onConfirmLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [this.state.searchLoginValue],
            isSearchLogin: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.LOGIN_FILTER, [_this.state.searchLoginValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.LOGIN_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
            // this.doReLoadPlayersList();
        });
    };
    PartnersList.prototype.onConfirmEMailFilter = function () {
        var _this = this;
        this.setState({
            searchEMailFilter: [this.state.searchEMailValue],
            isSearchEmail: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.EMAIL_FILTER, [_this.state.searchEMailValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.EMAIL_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
            // this.doReLoadPlayersList();
        });
    };
    PartnersList.prototype.getIconLogin = function () {
        if (!this.state.isSearchLogin) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PartnersList.prototype.getIconEmail = function () {
        if (!this.state.isSearchEmail) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PartnersList.prototype.getColumns = function () {
        var _this = this;
        var _login_filter = this.state.searchLoginFilter;
        var _email_filter = this.state.searchEMailFilter;
        return ([{
                title: 'Логин',
                dataIndex: this.props.data.dk_login,
                key: this.props.data.dk_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchLoginInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchLoginValue, onChange: _this.onChangeLoginFilter.bind(_this), onPressEnter: function () { _this.onConfirmLoginFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmLoginFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearLoginFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _login_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconLogin(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchLoginInput.focus();
                        });
                    }
                }
            }, {
                title: 'Аффилейт',
                dataIndex: this.props.data.dk_affilate_title,
                key: this.props.data.dk_affilate_title,
                width: 150,
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_currency_title,
                key: this.props.data.dk_currency_title,
                width: 70,
                align: "center"
            }, {
                title: 'Язык',
                dataIndex: this.props.data.dk_language_title,
                key: this.props.data.dk_language_title,
                width: 70,
                align: "center"
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать аффилейта", text: "Да" }, unlockedTexts: { menu: "Разблокировать аффилейта", text: "Нет" }, record: { key: record.key, title: record.login, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 100,
            }, {
                title: 'EMail',
                dataIndex: this.props.data.dk_email,
                key: this.props.data.dk_email,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchEMailInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0435\u043C\u044D\u0439\u043B", value: _this.state.searchEMailValue, onChange: _this.onChangeEMailFilter.bind(_this), onPressEnter: function () { _this.onConfirmEMailFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmEMailFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearEMailFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _email_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconEmail(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.email.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchEMailInput.focus();
                        });
                    }
                },
                render: function (text, record, idx) {
                    if (record.is_email_confirmed) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "green" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                            " ",
                            record.email));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "red" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                            " ",
                            record.email));
                    }
                },
                width: 150,
            } /*, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 150,
            }*/,
            {
                title: 'Кол-во И/ПП/ВП',
                dataIndex: this.props.data.dk_child_partners_count_level_all,
                key: this.props.data.dk_child_partners_count_level_all,
                width: 130,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "users" }),
                        " ",
                        record.child_players_count,
                        "/",
                        record.child_partners_count_level_one,
                        "/",
                        record.child_partners_count_level_all));
                }
            }, {
                title: 'Баланс Тек./След.',
                dataIndex: this.props.data.dk_balance_current,
                key: this.props.data.dk_balance_current,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "wallet" }),
                        " ",
                        record.balance_current.toFixed(2),
                        "/",
                        record.balance_next.toFixed(2)));
                }
            }, {
                title: 'Добавлен',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                },
                width: 140,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionUser_1.default, { hint: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0442\u043E\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430", onClick: function () { _this.onChangeOwnerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }),
                    React.createElement(TableActionMoreActions_1.default, { hint: "\u0415\u0449\u0435", menu: _this.getMoreActionsDropDownMenu(record) }))); },
                width: 100
            }
        ]);
    };
    PartnersList.prototype.onChangeOwnerClick = function (record) {
        var _this = this;
        this.props.dlgSetTopPartner.SetDialogTitle("Изменить топ партнера").SetOnYesClick(function (pprogram, partner) {
            _this.props.data.SetTopPartner(record.key, partner, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u043E\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u0434\u043B\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 ",
                    React.createElement("b", null,
                        "[",
                        record.login,
                        "]"),
                    " \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D!"));
            });
        }).Show();
    };
    PartnersList.prototype.onConfigClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    PartnersList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    PartnersList.prototype.onDeletePlayerClick = function (record) {
        var _this = this;
        this.props.data.DeletePlayer(record.key, function () {
            _this.doReLoadPartnersList(function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        record.login,
                        "]"),
                    " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
            });
        });
    };
    PartnersList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.doReLoadPartnersList(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PartnersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.doReLoadPartnersList();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    PartnersList.prototype.onAffilateFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onAffilateFilterChanged) {
            this.props.onAffilateFilterChanged(allBrands, BrandId, Action);
        }
    };
    PartnersList.prototype.doNewAction = function (e) {
        if (e.key == this.ACTION_NEW_PARTNER) {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (e.key == this.ACTION_NEW_BROADCAST_RAW) {
            if (this.props.onSendBroadcastRawClick) {
                this.props.onSendBroadcastRawClick();
            }
        }
        /*if(e.key == this.ACTION_NEW_BROADCAST_TPL) {
            if(this.props.onSendBroadcastTplClick) {
                this.props.onSendBroadcastTplClick();
            }
        }*/
        console.log("new action -> " + e.key);
    };
    PartnersList.prototype.getNewButtonActionsDropDownMenu = function () {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doNewAction(e); } },
            React.createElement(antd_1.Menu.Item, { key: this.ACTION_NEW_PARTNER },
                React.createElement(FontAwesome_1.FA, { icon: "eye", left: true }),
                "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.ACTION_NEW_BROADCAST_RAW },
                React.createElement(FontAwesome_1.FA, { icon: "comment-alt", left: true }),
                "\u041D\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435")));
    };
    PartnersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, menu: { create: this.getNewButtonActionsDropDownMenu() }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allAffilates, availBrands: this.props.availAffilates, captions: { checkbox: "Все п.программы", placeholder: "Выберите п.программу" }, selectedBrands: this.props.affilatesList, onBrandFilterChanged: this.onAffilateFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0412\u0430\u043B\u044E\u0442\u0430:"),
                        " [",
                        record.app_currency_title,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u042F\u0437\u044B\u043A \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430:"),
                        " [",
                        record.app_language_title,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430:"),
                        " [",
                        UIUtils_1.UIUtils.bool2Str(record.is_email_confirmed, "Да", "Нет"),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A\u043E\u0432:"),
                        " [",
                        record.child_players_count,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041F\u0440\u044F\u043C\u044B\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432:"),
                        " [",
                        record.child_partners_count_level_one,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0412\u0441\u0435\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432:"),
                        " [",
                        record.child_partners_count_level_all,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                        " [",
                        record.description,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041D\u0430\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0444\u0444\u0435\u0440\u043E\u0432:"),
                        " [",
                        record.offer_inheritance_type_title,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0422\u043E\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440:"),
                        " [",
                        record.top_partner_login,
                        "]")); }, scroll: { x: true } })));
    };
    return PartnersList;
}(React.Component));
exports.default = PartnersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/PartnersList.tsx
// module id = 2431
// module chunks = 0